module.exports = {
	"languageId": "en-GB",
	"currencyId": "GBP",
	"format": {
		"nullString": "-",
		"any": {
			"dataType": "any",
			"number": {
				"dataType": "number",
				"style": "decimal",
				"useGrouping": true,
				"minimumFractionDigits": 0,
				"maximumFractionDigits": 2,
				"abbreviate": {},
				"nullString": "-"
			},
			"date": {
				"dataType": "date",
				"year": "numeric",
				"month": "numeric",
				"day": "numeric",
				"nullString": "-"
			},
			"nullString": "-"
		},
		"number": {
			"dataType": "number",
			"style": "decimal",
			"useGrouping": true,
			"minimumFractionDigits": 0,
			"maximumFractionDigits": 2,
			"abbreviate": {},
			"nullString": "-"
		},
		"date": {
			"dataType": "date",
			"year": "numeric",
			"month": "numeric",
			"day": "numeric",
			"nullString": "-"
		}
	},
	"formatAliases": {
		"defaultAny": {
			"dataType": "any",
			"number": "shortDecimal",
			"date": "yyyy-mm-dd"
		},
		"standardDecimal": {
			"dataType": "number",
			"minimumFractionDigits": 0,
			"maximumFractionDigits": 2
		},
		"integer": {
			"dataType": "number",
			"minimumFractionDigits": 0,
			"maximumFractionDigits": 0
		},
		"shortDecimal": {
			"dataType": "number",
			"minimumFractionDigits": 2,
			"maximumFractionDigits": 2
		},
		"longDecimal": {
			"dataType": "number",
			"minimumFractionDigits": 3,
			"maximumFractionDigits": 3
		},
		"yyyy-mm-dd": {
			"dataType": "date",
			"year": "numeric",
			"month": "numeric",
			"day": "numeric"
		},
		"yyyy-mmmm-dd": {
			"dataType": "date",
			"year": "numeric",
			"month": "long",
			"day": "numeric"
		},
		"yyyy-mmm-dd": {
			"dataType": "date",
			"year": "numeric",
			"month": "short",
			"day": "numeric"
		},
		"yyyy-mmm-dd-hh-mm": {
			"dataType": "date",
			"year": "numeric",
			"month": "short",
			"day": "numeric",
			"hour": "numeric",
			"minute": "numeric"
		},
		"yy-mmm-dd": {
			"dataType": "date",
			"year": "2-digit",
			"month": "short",
			"day": "numeric"
		}
	},
	"colors": null,
	"colorPaletteName": "charts",
	"colorPalettes": {
		"areaChart": [
			"#000",
			"#333",
			"#666",
			"#999",
			"#CCC",
			"#EEE"
		],
		"assetAllocations": [
			"#000",
			"#333",
			"#666",
			"#999",
			"#CCC",
			"#EEE"
		],
		"charts": [
			"#000",
			"#333",
			"#666",
			"#999",
			"#CCC",
			"#EEE"
		],
		"fixedIncomeStyleBox": [
			"#000",
			"#333",
			"#666",
			"#999",
			"#CCC",
			"#EEE"
		],
		"lineChart": [
			"#000",
			"#333",
			"#666",
			"#999",
			"#CCC",
			"#EEE"
		],
		"pieChart": [
			"#000",
			"#333",
			"#666",
			"#999",
			"#CCC",
			"#EEE"
		],
		"stockStyleBox": [
			"#000",
			"#333",
			"#666",
			"#999",
			"#CCC",
			"#EEE"
		]
	},
	"fieldDefinitions": {
		"categoryId": {
			"requiredFields": []
		},
		"categoryName": {
			"requiredFields": []
		},
		"closePrice": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"debtEquityRatio": {
			"requiredFields": [],
			"format": "longDecimal"
		},
		"dividendYield": {
			"requiredFields": [],
			"format": "longDecimal"
		},
		"epsGrowth5Y": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"expenseRatio": {
			"requiredFields": [],
			"format": "standardDecimal"
		},
		"industryName": {
			"requiredFields": []
		},
		"name": {
			"requiredFields": []
		},
		"marketCap": {
			"requiredFields": [],
			"format": {
				"dataType": "number",
				"style": "decimal",
				"abbreviate": {
					"mode": "auto"
				}
			}
		},
		"priceBookRatio": {
			"requiredFields": [],
			"format": "standardDecimal"
		},
		"priceCurrency": {
			"requiredFields": []
		},
		"priceEarningsRatio": {
			"requiredFields": [],
			"format": "standardDecimal"
		},
		"priceSalesRatio": {
			"requiredFields": [],
			"format": "standardDecimal"
		},
		"rating": {
			"requiredFields": []
		},
		"returnD1": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"returnW1": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"returnM0": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"returnM1": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"returnM3": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"returnM6": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"returnM12": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"returnM36": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"returnM60": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"returnM120": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"revenueGrowth3Y": {
			"requiredFields": [],
			"format": "shortDecimal"
		},
		"roettm": {
			"requiredFields": [],
			"format": "longDecimal"
		},
		"salesYield": {
			"requiredFields": [],
			"format": "longDecimal"
		},
		"sectorName": {
			"requiredFields": []
		}
	},
	"viewBreakpoints": {
		"small": 640,
		"medium": 1024,
		"large": 1440,
		"xlarge": 1920
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./components/core/src/config/default-base-settings.json
 ** module id = 115
 ** module chunks = 0
 **/